module.exports = __webpack_public_path__ + "img/stena10.02f70715.jpg";